import { render, staticRenderFns } from "./Workcenters.vue?vue&type=template&id=272dcd52&"
import script from "./Workcenters.vue?vue&type=script&lang=js&"
export * from "./Workcenters.vue?vue&type=script&lang=js&"
import style0 from "./Workcenters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports